import {PageType} from '@/_application/core/types';
import {Routes} from '@/config/routes';

export const ROUTES_HIDE_BOTTOM_NAVIGATION = new Set([Routes.cart, Routes.checkout, Routes.auth]);
export const ROUTES_HIDE_TOP_NAVIGATION = new Set([Routes.home, Routes.orderSuccess, Routes.orderFailed]);
export const PAGES_HIDE_CHAT_WIDGE = new Set([PageType.PRODUCT_DETAIL, PageType.CART, PageType.CHECKOUT]);
export const ROUTES_MOBILE_HIDE_CHAT_WIDGE = new Set([Routes.checkout, Routes.cart, Routes.auth]);
